export default "__VITE_ASSET__ChjE2Q0I__"